<template>
  <div class="appointment-schedule-doctor">
    <div @click="showDetail" class="appointment-schedule-doctor-info">
      <van-image :src="doctorInfo.portrait" class="doctor-protrait" alt="">
        <img slot="error" :src="require('@assets/ic_doctor.png')" alt="" />
      </van-image>
      <!-- <img v-lazy="doctorInfo.portrait" alt="" /> -->
      <div>
        <div class="appointment-schedule-doctor-info-name">
          {{ `${doctorInfo.doctorName || ""} ${doctorInfo.title || ""}` }}
        </div>
        <div
          class="appointment-schedule-doctor-info-introduce van-multi-ellipsis--l2"
        >
          {{ doctorInfo.introduction }}
        </div>
      </div>
    </div>
    <div
      v-for="department in doctorInfo.departmentList"
      :key="department.appointOfficeCode"
      class="appointment-schedule-doctor-schedule-list"
    >
      <span>
        {{ department.appointOfficeName }}
      </span>
      <AppointmentScheduleDate
        :list="department.appointmentList"
        :doctor-info="doctorInfo"
        :qrtype="qrtype"
      />
    </div>
  </div>
</template>

<script>
import AppointmentScheduleDate from "./components/AppointmentScheduleDate";

export default {
  components: {
    AppointmentScheduleDate
  },
  data() {
    return {
      doctorInfo: {},
      showPopupWindow: false,
      pageInfo: {},
      doctorList: [],
      departmentList: [],
      numberList: [],
      dayRange: 10,
      qrtype: "1"
    };
  },
  created() {
    this.qrtype = this.$route.query.qrtype || "1";
    this.pageInfo = this.$route.query;
    this.initDoctorList();
    this.doctorInfo = {
      portrait: this.pageInfo.portrait,
      doctorName: this.pageInfo.title,
      title: this.pageInfo.level,
      introduction: this.pageInfo.intro
    };
  },
  methods: {
    initDoctorList() {
      const startDate = this.$moment().format("YYYYMMDD");
      const endDate = this.$moment()
        .add(this.dayRange, "day")
        .format("YYYYMMDD");
      this.$http
        .post(this.$api.APPOINTMENT_DOCTOR_SCHEDULE_LIST_DOCTOR, {
          appointDoctorCode: this.pageInfo.id,
          startDate,
          endDate
        })
        .then(res => {
          this.doctorInfo = {
            portrait: res.photourl,
            doctorName: res.appointDoctorName,
            title: res.levelname,
            introduction: res.intro,
            departmentName: res.appointOfficeName,
            departmentId: res.appointOfficeCode,
            departmentList: res.officeList
          };
        })
        .catch(() => {
          // this.doctorInfo = {};
        });
    },
    // 跳转医生明细
    showDetail() {
      this.$router.push({
        name: "doctor-detail",
        query: {
          doctorNo: this.pageInfo.id,
          nobutton: true
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.appointment-schedule-doctor {
  &-info {
    display: flex;
    .doctor-protrait {
      margin: 1rem;
    }

    &-name {
      padding-top: 0.8rem;
    }

    &-introduce {
      margin-top: 0.2rem;
      margin-right: 0.8rem;
      color: #959595;
      font-size: 0.88rem;
    }
  }
  &-schedule-list {
    margin-top: 1rem;
    > span {
      // width: 100%;
      margin-left: 0.5rem;
      font-weight: 500;
    }
  }
}
</style>
